<crm-checklist-reschedule-form
  *ngIf="!saving"
  [isExtendTime]="isExtendTime"
  [canDelete]="!isExtendTime"
  [info]="info"
  [project]="project"
  (save)="save($event)"></crm-checklist-reschedule-form>

<crm-spinner *ngIf="saving"></crm-spinner>
